import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'getIntegrationStatus';

export function useIntegrationStatus({
	provider,
	refetchOnWindowFocus = true,
	userSession,
	meta,
}: {
	provider: string;
	refetchOnWindowFocus?: boolean;
	userSession: Api.IUserSessionContext;
	meta?: LevStandardQueryMeta;
}) {
	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IIntegrationStatus>(
				`user/integrations/${encodeURIComponent(provider)}/status`,
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, provider],
		refetchOnWindowFocus,
		meta,
	});
}

export const invalidateIntegrationStatus = (provider: string) => {
	return reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, provider] });
};
